import { Component } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
// import { IonIcon } from '@ionic/angular/standalone';
import { Store } from '@ngxs/store';
// import { addIcons } from 'ionicons';
// import
// {
//   alertCircle,
//   alertCircleOutline,
//   checkmarkCircle,
//   checkmarkCircleOutline,
//   closeCircle,
//   refreshOutline
// } from 'ionicons/icons';
import { AuthAction } from './store/auth/auth.actions';
import { TOKEN } from './util/constants';
import { SharedModule } from './util/shared.module';
import { ExceptionHandler } from './util/error-handler';
import { LoggerService } from './services/logger/logger.service';
import { environment } from './environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [SharedModule, RouterOutlet],
})
export class AppComponent
{
  constructor(
    private _logger: LoggerService,
    private route: ActivatedRoute,
    private store: Store
  )
  {

    console.log(`%cv${ environment.version }`, "font-size: 1.5vw;color: #2599d8;");

    // this.addIcons();

    this.route.queryParams.subscribe((param) =>
    {
      if (param && param[TOKEN.AUTH_TOKEN])
      {
        this.store.dispatch(new AuthAction({
          [TOKEN.SHOPIFY_PROVIDER_TOKEN]: param[TOKEN.SHOPIFY_PROVIDER_TOKEN] ?? null,
          [TOKEN.AUTH_TOKEN]: param[TOKEN.AUTH_TOKEN],
          [TOKEN.API_URL]: param[TOKEN.API_URL]
        }));
      }
    });
  }

  @ExceptionHandler()
  private addIcons()
  {
    // addIcons({
    //   checkmarkCircle,
    //   closeCircle,
    //   alertCircle,
    //   checkmarkCircleOutline,
    //   alertCircleOutline,
    //   refreshOutline
    // });
  }
}
